import React from 'react'
import { DEFAULT_FLAVOUR } from 'constants/flavours'
import { BackToMainMenuLink } from 'pages/documentsall/Main'

export default () => (
  <div className='pt9'>
    <div className='layout-width-constraint'>
      <div>
        <div className='flex'>
          <BackToMainMenuLink flavour={DEFAULT_FLAVOUR} view='browse' />
        </div>
      </div>
    </div>
  </div>
)
